import * as React from 'react';
import styled from 'styled-components';
import LoadingIcon from '../../Shared/LoadingIcon';
import { IYado, ICurrency } from '../types';
import { priceWithCommas } from '../../utils/commonHelper';
import t from '../locales';

interface IProps {
  currency: ICurrency;
  yado: IYado;
  numberOfPeople: number;
  numberOfNights: number;
}

const PriceView = styled.div`
  margin: 0.5em;
  align-self: flex-end;
  text-align: right;
  color: var(--gray900);
  .price__info__txt {
    margin: 0;
    padding: 0;
    font-size: 10px;
    font-weight: 400;
  }
  .price__info__total {
    margin: 0;
    padding: 0;
    font-size: 18px;
    font-weight: 600;
    span {
      font-size: 12px;
      margin-right: 4px;
    }
  }
`;

const ShowPriceView = styled.div`
  font-size: 1em;
  font-weight: bold;
  border: none;
  background-color: transparent;
`;

const YadoItemPrice: React.FC<IProps> = (props) => {
  const { yado, numberOfPeople, numberOfNights, currency } = props;
  const { isPriceLoaded, lowestPrice } = yado;
  const { rate, code } = currency;

  if (isPriceLoaded === undefined) {
    return (
      <PriceView>
        <ShowPriceView>
          {t.checkPrice()}
        </ShowPriceView>
      </PriceView>
    );
  }
  if (isPriceLoaded === false) {
    return (
      <PriceView>
        <p className="price__info__txt">Loading...</p>
        <p className="price__info__total"><LoadingIcon /></p>
      </PriceView>
    );
  }
  if (isPriceLoaded === true && lowestPrice == null) {
    return (
      <PriceView>
        <p className="price__info__txt">{t.noRoomsAvailableForTheSelectedDate()}</p>
        <p className="price__info__total">{t.soldOut()}</p>
      </PriceView>
    );
  }
  return (
    <PriceView>
      <p className="price__info__txt">
        {numberOfPeople && numberOfNights &&
          `${t.guestAndNightCount({ guests: numberOfPeople, nights: numberOfNights })} ${t.lowestPrice()}`}
      </p>
      <p className="price__info__total">
        {priceWithCommas(lowestPrice * rate) &&
          <React.Fragment>
            <span>{code}</span>
            {`${priceWithCommas(lowestPrice * rate)}〜 `}
          </React.Fragment>
        }
        {lowestPrice &&
          <React.Fragment>
            <span>(JPY</span>
            {`${Math.round(lowestPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}〜`}
            <span>)</span>
          </React.Fragment>
        }
      </p>
    </PriceView>
  )
}

export default YadoItemPrice;
